if (typeof ProductSizeGuide !== 'function') {
    class ProductSizeGuide extends HTMLElement {
        constructor() {
            super()

            // open first tab by default
            const firstButton = this.querySelectorAll('.size-guide__tabs-button')
            const firstContent = this.querySelectorAll('.size-guide__contents-item')

            if (firstButton[0] && firstContent[0]) {
                firstButton[0].classList.add('size-guide__tabs-button--active')
                firstContent[0].style.display = 'block'
            }

            this.addEventListener('click', (e) => {
                const target = e.target.dataset.target
                if (typeof target !== 'undefined') {
                    const { buttons, tabs } = this.getAllButtonsAndTabs()

                    // remove all active class for buttons
                    buttons.forEach((button) => {
                        button.classList.remove('size-guide__tabs-button--active')
                    })

                    // add active class to the clicked button
                    e.target.classList.add('size-guide__tabs-button--active')

                    // hide all tabs
                    tabs.forEach((tab) => tab.style.display = 'none')

                    // show the tab for the clicked button
                    this.querySelector(target).style.display = 'block'
                }
            })
        }

        getAllButtonsAndTabs() {
            const buttons = this.querySelectorAll('.size-guide__tabs-button')
            const tabs = this.querySelectorAll('.size-guide__contents-item')

            return {buttons, tabs}
        }
    }

    if ( typeof customElements.get('product-size-guide') == 'undefined' ) {
        customElements.define('product-size-guide', ProductSizeGuide);
      }
}